import { Link, Route } from "react-router-dom/cjs/react-router-dom.min";
import { useEffect, useState } from "react";
import DitapMAin from "./DitapMain";
import DitapJs from "./DitapJs";
import DitapUnity from "./DitapUnity";
import DitapBuilder from "./DitapBuilder";
import { useMediaQuery } from "react-responsive";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

function Ditap({ match }) {
  const [name, setName] = useState("");
  const [cont1, setCont1] = useState("");
  const [cont2, setCont2] = useState("");

  const getData = (name, cont1, cont2) => {
    setName(name);
    setCont1(cont1);
    setCont2(cont2);
  };

  const btnBox = document.getElementsByClassName("swiper-wrapper")[0];
  const pcBtnBox = document.getElementsByClassName("basic-item")[0];
  const mobBtnBox = document.getElementsByClassName("swiper-slide")[0];
  const link = document.location.href;

  useEffect(() => {
    //pc일때만 실행
    if (1023 < window.innerWidth) {
      onPcMovePage();
    } else {
      onMobMovePage();
    }
  });

  //링크에 따른 클래스 부여
  if (link.includes("overview")) {
    classRemove(btnBox?.children);
    btnBox?.children[0]?.classList.add("on");
  } else if (link.includes("ditapjs")) {
    classRemove(btnBox?.children);
    btnBox?.children[1]?.classList.add("on");
  } else if (link.includes("ditapforunity")) {
    classRemove(btnBox?.children);
    btnBox?.children[2]?.classList.add("on");
  } else if (link.includes("ditapbuilder")) {
    classRemove(btnBox?.children);
    btnBox?.children[3]?.classList.add("on");
  }

  //pc
  const onPcMovePage = () => {
    if (link.includes("overview")) {
      classRemove(pcBtnBox?.children);
      pcBtnBox?.children[0]?.classList.add("on");
    } else if (link.includes("ditapjs")) {
      classRemove(pcBtnBox?.children);
      pcBtnBox?.children[1]?.classList.add("on");
    } else if (link.includes("ditapforunity")) {
      classRemove(pcBtnBox?.children);
      pcBtnBox?.children[2]?.classList.add("on");
    } else if (link.includes("ditapbuilder")) {
      classRemove(pcBtnBox?.children);
      pcBtnBox?.children[3]?.classList.add("on");
    }
  };

  //mob
  const onMobMovePage = () => {
    if (link.includes("overview")) {
      classRemove(mobBtnBox?.children);
      mobBtnBox?.children[0]?.classList.add("on");
    } else if (link.includes("ditapjs")) {
      classRemove(mobBtnBox?.children);
      mobBtnBox?.children[1]?.classList.add("on");
    } else if (link.includes("ditapforunity")) {
      classRemove(mobBtnBox?.children);
      mobBtnBox?.children[2]?.classList.add("on");
    } else if (link.includes("ditapbuilder")) {
      classRemove(mobBtnBox?.children);
      mobBtnBox?.children[3]?.classList.add("on");
    }
  };

  //on 클래스 삭제
  function classRemove(arr) {
    for (let i = 0; i < arr?.length; i++) {
      arr[i].classList.remove("on");
    }
  }

  const pc = useMediaQuery({
    query: "(min-width : 1024px)",
  });

  return (
    <>
      <div className="basic-main">
        <div className="basic-visual ditap-visual">
          <div className="inner">
            <h2 className="basic-visual-title">{name}</h2>
            <div className="basic-visual-cont">
              {pc ? (
                <>
                  <p>{cont1}</p>
                  <p>{cont2}</p>
                </>
              ) : (
                <>
                  <p>
                    {cont1}
                    {cont2}
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="basic-tap">
          {pc ? (
            <ul className="basic-item">
              <li className="basic-list">
                <Link to="/ditap/overview" className="basic-link">
                  DiTAP
                </Link>
                <span className="line"></span>
              </li>
              <li className="basic-list">
                <Link to="/ditap/ditapjs" className="basic-link">
                  DiTAP JS
                </Link>
                <span className="line"></span>
              </li>
              <li className="basic-list">
                <Link to="/ditap/ditapforunity" className="basic-link">
                  DiTAP for Unity
                </Link>
                <span className="line"></span>
              </li>
              <li className="basic-list">
                <Link to="/ditap/ditapbuilder" className="basic-link">
                  DiTAP Builder
                </Link>
                <span className="line"></span>
              </li>
            </ul>
          ) : (
            <div className="basic-item mobile-basic-item">
              <Swiper slidesPerView={"auto"}>
                <SwiperSlide>
                  <div className="basic-list">
                    <Link to="/ditap/overview" className="basic-link">
                      DiTAP
                    </Link>
                    <span className="line"></span>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="basic-list">
                    <Link to="/ditap/ditapjs" className="basic-link">
                      DiTAP JS
                    </Link>
                    <span className="line"></span>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="basic-list">
                    <Link to="/ditap/ditapforunity" className="basic-link">
                      DiTAP for Unity
                    </Link>
                    <span className="line"></span>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="basic-list">
                    <Link to="/ditap/ditapbuilder" className="basic-link">
                      DiTAP Builder
                    </Link>
                    <span className="line"></span>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          )}
        </div>
      </div>
      <div className="basic-inner">
        <Route
          path={`${match.path}/overview`}
          exact={true}
          render={() => <DitapMAin getData={getData} />}
        />
        <Route
          path={`${match.path}/ditapjs`}
          render={() => <DitapJs getData={getData} />}
        />
        <Route
          path={`${match.path}/ditapforunity`}
          render={() => <DitapUnity getData={getData} />}
        />
        <Route
          path={`${match.path}/ditapbuilder`}
          render={() => <DitapBuilder getData={getData} />}
        />
      </div>
    </>
  );
}

export default Ditap;
